import { Box, Center } from '@chakra-ui/layout'
import { Image } from '@chakra-ui/react'
import React from 'react'
import type { APIUser } from '../../api'
import { addIcon } from '../../assets/svg'
import { useUserAwareTranslation } from '../../i18n/hooks'
import { ButtonPrimary } from '../Base'

interface AddCardProps {
  user?: APIUser
  onClick?: React.MouseEventHandler
}

const AddCard = ({ user, onClick }: AddCardProps) => {
  const { t } = useUserAwareTranslation(user)
  return (
    <Box w="100%" bg="michelinPrimary" m={[0, 4]} ml={[0]} borderRadius={4} p={5} boxShadow="lg">
      <Center flexDirection={'column'} h={['77px', '260px']}>
        <Image src={addIcon} boxSize={['40px', '75px']} />
      </Center>
      <ButtonPrimary w="100%" onClick={onClick}>
        {t('add-image')}
      </ButtonPrimary>
    </Box>
  )
}

export default AddCard
